import { useShoppingCart } from "../context/ShoppingCartContext";
import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./ProductServicesCartItem.css";
import usePageLanguage from "../hooks/usePageLanguage";
import { getCatalogProductDisplayFields } from "../utilities/catalogProductAdapter";

type ProductServicesCartItemProps = {
  productUuid: string;
  quantity: number;
};

export default function ProductServicesCartItem({
  productUuid,
  quantity,
}: ProductServicesCartItemProps) {
  const {
    getCatalogEntryByUuid,
    decreaseCartQuantity,
    setCartQuantity,
    increaseCartQuantity,
  } = useShoppingCart();

  const lang = usePageLanguage();
  const entry = productUuid ? getCatalogEntryByUuid(productUuid) : undefined;
  const parent = entry?.parent;

  if (!parent) {
    return null;
  }

  const display = getCatalogProductDisplayFields(parent, lang);

  return (
    <div className="productServiceCartItem">
      <div className="productsServiceCartItemImage">
        <span style={{ fontSize: "12px" }}>image</span>
      </div>

      <div className="productServiceCartItemName">
        <span>{display.displayName}</span>

        <div className="productServiceCartItemQuantity">
          <RemoveIcon
            className="productServicesCartButton"
            style={{ cursor: "pointer", fontSize: "21px" }}
            onClick={() => decreaseCartQuantity(productUuid)}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              name="quantity"
              value={quantity}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCartQuantity(+e.target.value, productUuid)
              }
              style={{
                display: "inline-block",
                width: "20px",
                backgroundColor: "transparent",
                border: "none",
                textAlign: "right",
              }}
            />{" "}
            {parent.unitShortname}{" "}
          </div>
          <AddIcon
            className="productServicesCartButton"
            style={{ cursor: "pointer", fontSize: "21px", marginLeft: "5px" }}
            onClick={() =>
              increaseCartQuantity(
                productUuid,
              )
            }
          />
        </div>
      </div>
    </div>
  );
}
